import { useLocation } from 'react-router';

export const useIsInAssist = () => {
  const { pathname } = useLocation();
  return pathname.startsWith('/assist');
};
